module.exports = new __parcel__URL__("mining_defeat_badge.7a4266b6.png").toString();